const api = {
  login: '/webApi/login',
  updateUserInfo: '/webApi/userInfo/updateUserInfo',
  getUserInfo: '/webApi/userInfo/getUserInfo',
  logout: '/webApi/logout',
  ssoLogout: 'https://hep-center.u2.hep.com.cn/logout' /* sso退出登录 */,
  specialList: '/webApi/special/specialList',
  specailSearch: '/webApi/special/tSpecialSubjectSearchList',
  adList: '/webApi/ad/adList',
  userLike: '/webApi/special/userLike',
  defaultSearchText: '/webApi/platformConfig/getPlatformSearchKey',
  fpglOpen: '/webApi/invoice/fpglOpen',
  appConfig:'/dev-api/website/websiteConfig/list'
};

export default api;
